export const QUERY_KEY = 'bills';
export const USER_BILLS_QUERY_KEY = 'user-bills';
